/**
 * components/procurement/BeaconShimmer.jsx — animated "Beacon is cooking" status.
 *
 * Cycles through real-sounding data-gathering steps with a shimmering gradient
 * sweep so it's intuitive that Beacon is genuinely pulling from many sources
 * (properties, meters, units, bills, historical data, contracts, market feeds).
 */
import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

export const BEACON_STEPS = [
  'Going through your properties…',
  'Scanning meters & units…',
  'Looking into the bills…',
  'Crunching historical data…',
  'Reviewing your contracts…',
  'Checking live market feeds…',
  'Modelling the projection…',
  'Nearly there…',
];

const SHIMMER_CSS = `
@keyframes beaconShimmer {
  0% { background-position: 200% center; }
  100% { background-position: -200% center; }
}
.beacon-shimmer-text {
  background: linear-gradient(90deg, #7c3aed 0%, #c084fc 25%, #7c3aed 50%, #c084fc 75%, #7c3aed 100%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: beaconShimmer 2.4s linear infinite;
}
`;

export function BeaconShimmer({ steps = BEACON_STEPS, className = '' }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % steps.length), 1500);
    return () => clearInterval(t);
  }, [steps.length]);

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="beacon-shimmer">
      <style>{SHIMMER_CSS}</style>
      <Sparkles className="w-4 h-4 text-violet-600 animate-pulse shrink-0" />
      <span key={i} className="beacon-shimmer-text text-sm font-medium">{steps[i]}</span>
    </div>
  );
}
